export default "__VITE_ASSET__Cjaa1BGK__"